import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { OidcSecurityService } from 'angular-auth-oidc-client'
import { switchMap, take } from 'rxjs'
import { environment } from '../../environments/environment'

/**
 * Attaches `Authorization: Bearer <access token>` to every request aimed at
 * the TakeTheme API (environment.apiUrl — api.taketheme.com in prod). All
 * other hosts pass through untouched so the token never leaks to third
 * parties (e.g. the Authentik endpoints the OIDC library calls itself).
 * Also sends the admin's UI language as `Accept-Language`, so backend
 * validation/error messages come back in the staff member's language
 * (staff tokens carry no `viewLanguage`).
 */
export const apiAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req)
  }

  const oidcSecurityService = inject(OidcSecurityService)
  const translate = inject(TranslateService, { optional: true })
  const lang = translate?.currentLang || translate?.defaultLang
  return oidcSecurityService.getAccessToken().pipe(
    take(1),
    switchMap(accessToken => {
      const setHeaders: Record<string, string> = {}
      if (accessToken) setHeaders['Authorization'] = `Bearer ${accessToken}`
      if (lang && !req.headers.has('Accept-Language')) setHeaders['Accept-Language'] = lang
      return next(Object.keys(setHeaders).length ? req.clone({ setHeaders }) : req)
    }),
  )
}
